export type Priority = 'urgent' | 'high' | 'medium' | 'low';

/** Backend priority mapping confirmed 2026-05-12:
 *  None = 0, Low = 1, Medium = 2, High = 3, Urgent = 4
 */
const PRIORITY_MAP: Record<Priority, number> = {
  urgent: 4,
  high: 3,
  medium: 2,
  low: 1,
};

const REVERSE_MAP: Record<number, Priority> = {
  4: 'urgent',
  3: 'high',
  2: 'medium',
  1: 'low',
};

/**
 * Converts a UI TaskPriority enum to the API integer value.
 * Returns null when no priority is selected.
 */
export function priorityToInt(p: Priority | undefined | null): number {
  if (p == null) return 0;
  return PRIORITY_MAP[p] ?? 0;
}

/**
 * Converts an API integer priority to the UI TaskPriority enum.
 * API value 0 (None) and null/undefined both map to undefined.
 * Unrecognized values fall back to undefined (default / no priority).
 */
export function priorityFromInt(n: number | null | undefined): Priority | undefined {
  if (n == null || n === 0) return undefined;
  return REVERSE_MAP[n] ?? undefined;
}
